<template lang="md">
# Datenschutzerklärung

Abbés Weinladen bedankt sich bei Ihnen für den Besuch. Der sichere Umgang mit den Daten unserer Besucher ist uns besonders wichtig. Daher informieren wir Sie im Folgenden über die Verwendung Ihrer Daten beim Besuch unserer Seiten.

## Verantwortlicher

Martina Abbe
Ringstraße 10A
12203 Berlin
Telefon: +49 (0)30 / 83 31 22 9
E-Mail: abbes.weinladen@web.de

Es besteht keine Pflicht zur Bestellung eines Datenschutzbeauftragten.

## Welche Daten werden verarbeitet?

Die angebotenen Seiten werden im Rahmen der Auftragsdatenververarbeitung durch die

ALL-INKL.COM - Neue Medien Münnich
Inhaber: René Münnich
Hauptstraße 68
02742 Friedersdorf, Deutschland

als technischem Dienstleister bereitgestellt. Beim Abruf von Seiten werden allgemeine Daten in den Logdateien der Server erfasst. Dies sind u.a.

- verwendeter Browser und -version
- das verwendete Betriebssystem
- die zuletzt besuchte Seite (sogenannter Referer)
- die jeweils abgerufene Seite
- Datum und Uhrzeit des Abrufs
- die abrufende IP-Adresse
- der Internet-Service-Provider (ISP)

Diese Daten werden anonym erhoben und dabei weder mit anderen personenbezogenen Daten zusammengeführt oder verglichen noch werden damit Rückschlüsse auf betroffene Personen gezogen. Tatsächlich benötigen wir die Daten für

- die optimale und korrekte Bereitstellung der Seiten
- die Erstellung von Inhalten und Werbematerial
- die Überwachung aller Server und deren korrekte Funktion
- die Erkennung von sogenannten Cyberangriffen auf unsere Infrastruktur und damit der Strafverfolgung durch behördliche Stellen

## Verwendung von Cookies

Um unsere Seiten ansprechend und funktional zu gestalten, setzen wir Cookies ein. Dabei verwenden wir sogenannte Session-Cookies, die gelöscht werden, sobald der Browser geschloßen wird und persistente Cookies, die darüberhinaus auch bei einem erneuten Besuch der Seite ausgelesen werden. Die Annahme von Cookies kann durch Browser überwacht und verhindert werden (Teil der Browsereinstellungen). Abgelehnte Cookies können die Nutzbarkeit der Seiten einschränken.

## Google Web Fonts

Die Google Web Fonts befinden sich auf unserem Server. Es wird keine weitere Verbindung zu Servern von Google aufgebaut.

## Google Analytics

Unsere Seiten nutzen Google Analytics, den Webanalysedienst der Google Inc. Google Analytics stellt Methoden bereit, um die Nutzung unserer Seiten zu analysieren. Dafür verwendet es Cookies, also Textdateien, die auf ihrem Computer gespeichert werden. Die im Rahmen der Analyse gesammelten Nutzungsdaten, werden im Browser anonymisiert (insbesondere die IP-Adresse betreffend) und an Server in den USA übertragen. In Ausnahmefällen erfolgt die Anonymisierung erst auf Servern in den USA.

Eine Zusammenführung mit anderen Daten von Google erfolgt nicht.

Sie können das weitere Erfassen und die Verarbeitung Ihrer Daten verhindern, indem Sie das unter folgendem Link verfügbare Browser-Plugin installieren: [Browser-Plugin](https://tools.google.com/dlpage/gaoptout?hl=de)

Alternativ dazu können Sie durch das Setzen des Hakens hier

<div class="mx-4 mt-10 mb-6"><label for="optout">Opt-Out&nbsp;</label><input name="optout" type="checkbox" @change="toggleTracking($event)" :checked="isDisabled"></div>

ein Opt-Out-Cookie setzen, das die Erfassung durch Google Analytics auf unseren Seiten verhindert. Sofern Sie dieses Cookies löschen, müssen Sie den Haken erneut setzen.

## Änderungsvorbehalt

Im Rahmen von Gesetzesänderungen oder der Erweiterung unserer Seiten behalten wir uns eine Anpassung dieser Datenschutzerklärung vor.

## Aktualisierung/Löschung persönlicher Daten

Sie können jederzeit Auskunft über die zu Ihrer Person gespeicherten Daten anfordern. Darüberhinaus haben Sie das Recht durch uns gespeicherte personenbezogene Daten bei uns ändern oder löschen (Widerruf der Einwilligung der Speicherung) zu lassen bzw. die vorliegenden Daten in einem maschinenlesbaren Format zu erhalten.

Stand: Oktober 2018

</template>

<script>
export default {
  computed: {
    isDisabled() {
      return this.optedOut()
    },
  },
  methods: {
    toggleTracking(event) {
      event.target.checked ? this.optOutGA() : this.optInGA()
    },
  },
}
</script>
